export default "__VITE_ASSET__DGADZ85A__"